import { useEffect } from "react";

// Su telefono le tabelle diventano liste: etichetta la cella con l'intestazione e apre il dettaglio al tocco
export function useTableLists() {
  useEffect(() => {
    const label = (table) => {
      const heads = [...table.querySelectorAll("thead th")].map((th) => th.textContent.trim());
      table.querySelectorAll("tbody tr").forEach((tr) => {
        [...tr.children].forEach((td, i) => { if (heads[i] && !td.dataset.label) td.dataset.label = heads[i]; });
      });
    };
    const run = () => document.querySelectorAll("table.w-full").forEach(label);
    run();
    const mo = new MutationObserver(run);
    mo.observe(document.body, { childList: true, subtree: true });
    const onClick = (e) => {
      if (window.innerWidth >= 768) return;
      if (e.target.closest("a,button,select,input,label")) return;
      const tr = e.target.closest("table.w-full tbody tr");
      if (tr && tr.children.length > 2) tr.toggleAttribute("data-open");
    };
    document.addEventListener("click", onClick);
    return () => { mo.disconnect(); document.removeEventListener("click", onClick); };
  }, []);
}
